import { DATA_SOURCES_MAPPING } from './dataSources';

// device设备
export const DEVICES_MAPPING = {
  PC: 'pc',

  PLAYSTATION: 'PlayStation',
  PLAYSTATION4: 'PlayStation 4',
  PLAYSTATION5: 'PlayStation 5',

  XBOX: 'Xbox',
  XBOX_ONE: 'Xbox One',
  XBOX_SERIES_XS: 'Xbox Series X|S',

  NINTENDO: 'Nintendo',
  NINTENDO_WII_U: 'Nintendo Wii U',
  NINTENDO_SWITCH: 'Nintendo Switch',
};

// 设备名称
export const DEVICES_NAMES_MAPPING = {
  [DEVICES_MAPPING.PC]: 'PC',

  [DEVICES_MAPPING.PLAYSTATION]: 'PlayStation',
  [DEVICES_MAPPING.PLAYSTATION4]: 'PlayStation 4',
  [DEVICES_MAPPING.PLAYSTATION5]: 'PlayStation 5',

  [DEVICES_MAPPING.XBOX]: 'Xbox',
  [DEVICES_MAPPING.XBOX_ONE]: 'Xbox One',
  [DEVICES_MAPPING.XBOX_SERIES_XS]: 'Xbox Series X|S',

  [DEVICES_MAPPING.NINTENDO]: 'Nintendo',
  [DEVICES_MAPPING.NINTENDO_WII_U]: 'Nintendo Wii U',
  [DEVICES_MAPPING.NINTENDO_SWITCH]: 'Nintendo Switch',
};

// 全部pc devices
export const ALL_PC_DEVICES = [DEVICES_MAPPING.PC];

// 全部console devices
export const ALL_CONSOLE_DEVICES = [
  DEVICES_MAPPING.PLAYSTATION,
  DEVICES_MAPPING.PLAYSTATION4,
  DEVICES_MAPPING.PLAYSTATION5,
  DEVICES_MAPPING.XBOX,
  DEVICES_MAPPING.XBOX_ONE,
  DEVICES_MAPPING.XBOX_SERIES_XS,
  DEVICES_MAPPING.NINTENDO,
  DEVICES_MAPPING.NINTENDO_WII_U,
  DEVICES_MAPPING.NINTENDO_SWITCH,
];

// 全部devices
export const ALL_DEVICES = [...ALL_PC_DEVICES, ...ALL_CONSOLE_DEVICES];

// 按数据源分类的devices集合
export const ALL_DEVICES_BY_DATASOURCES = {
  [DATA_SOURCES_MAPPING.NPD]: [
    DEVICES_MAPPING.PC,
    DEVICES_MAPPING.PLAYSTATION4,
    DEVICES_MAPPING.PLAYSTATION5,
    DEVICES_MAPPING.XBOX_ONE,
    DEVICES_MAPPING.XBOX_SERIES_XS,
    DEVICES_MAPPING.NINTENDO_WII_U,
    DEVICES_MAPPING.NINTENDO_SWITCH,
  ],
  [DATA_SOURCES_MAPPING.MSCIENCE]: [
    DEVICES_MAPPING.PC,
    DEVICES_MAPPING.PLAYSTATION,
    DEVICES_MAPPING.XBOX,
    DEVICES_MAPPING.NINTENDO,
  ],
  [DATA_SOURCES_MAPPING.NEWZOO]: [
    DEVICES_MAPPING.PC,
    DEVICES_MAPPING.PLAYSTATION4,
    DEVICES_MAPPING.PLAYSTATION5,
    DEVICES_MAPPING.XBOX_ONE,
    DEVICES_MAPPING.XBOX_SERIES_XS,
  ],
};
